import type { ProjectContext } from './context-types.js';

interface CacheEntry {
  value: ProjectContext;
  expiresAt: number;
}

const cache = new Map<string, CacheEntry>();

export function getCachedProjectContext(workspaceRoot: string): ProjectContext | null {
  const entry = cache.get(workspaceRoot);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    cache.delete(workspaceRoot);
    return null;
  }
  return entry.value;
}

export function setCachedProjectContext(workspaceRoot: string, value: ProjectContext, ttlMs = 5 * 60 * 1000): void {
  cache.set(workspaceRoot, { value, expiresAt: Date.now() + ttlMs });
}

export function invalidateProjectContext(workspaceRoot?: string): void {
  if (workspaceRoot) cache.delete(workspaceRoot);
  else cache.clear();
}
